module.exports = __webpack_public_path__ + "media/images/19-circle-check-green-8556e7ad8c01a985ec15807ea40e0649.png";